import {API} from "@/Composables/api";

const getInvitations = async (params = {}) => {
    return API.get(route("invitations.index"), params);
};

const getOutgoingInvitations = async (params = {}) => {
    return API.get(route("invitations.outgoing"), params);
};
const getInvitation = async (invitation, params = {}, toast = false) => {
    return API.get(route("invitations.show", {invitation}), params, toast);
};
const getAuthInvitation = async (invitation, params = {}, toast = false) => {
    return API.get(route("invitations.auth", {invitation}), params, toast);
};

const respondToInvitation = async (invitation, response) => {
    return API.put(route("invitations.update", invitation), {}, {response});
};

const resendInvitation = async (invitation) => {
    return API.post(route("invitations.resend", invitation));
};

const withdrawInvitation = async (invitation) => {
    return API.delete(route("invitations.destroy", invitation));
};

export {
    getInvitations,
    getOutgoingInvitations,
    respondToInvitation,
    getInvitation,
    getAuthInvitation,
    resendInvitation,
    withdrawInvitation,
};
